import React from "react";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { Spinner } from "../Utils/Loaders";

export const MedicalServiceInfo = ({ medicalService, isLoading }) => {
    const { t } = useTranslation();

    if (isLoading)
        return <Spinner />

    if (!medicalService || !medicalService.service)
        return null;

    return (
        <Row>
            <Col sm={12}>
                <div className="info">
                    <div><span className="card-label">{t("calendar.medicalServiceInfo.medicalService")}:</span> <span className="card-text">{medicalService.service?.serviceNameReference}</span></div>
                    <div><span className="card-label">{t("calendar.medicalServiceInfo.coversMedicalInsurance")}:</span> <span className="card-text">{medicalService.isCoveredByMedicalInsurance ? t("commons.yes") : t("commons.no")}</span></div>
                    {
                        medicalService.isCoveredByMedicalInsurance && medicalService.coverRequirements &&
                        <div><span className="card-label">{t("calendar.medicalServiceInfo.approvalRequired")}:</span> <span className="card-text">{medicalService.coverRequirements?.requiresApproval ? t("commons.yes") : t("commons.no")}</span></div>
                    }
                    {
                        medicalService.coverRequirements && medicalService.coverRequirements.requiredCopago &&
                        <div><span className="card-label">{t("calendar.medicalServiceInfo.copayRequired")}:</span> <span className="card-text">{medicalService.coverRequirements?.copagoComments}</span></div>
                    }
                    {
                        !medicalService.isCoveredByMedicalInsurance && medicalService.price &&
                        <>
                            <div><span className="card-label">{t("calendar.medicalServiceInfo.price")}:</span> <span className="card-text">{medicalService.service?.serviceNameReference}</span></div>
                            <div>
                                <span className="card-label">{t("calendar.medicalServiceInfo.priceNotes")}</span>
                            </div>
                        </>
                    }
                </div>
            </Col>
        </Row>
    );
}